module.exports = __webpack_public_path__ + "static/media/seven_monkeys.b615b295.png";